import React from 'react'
import {
  HiddenContainer,
  Container,
  Box,
  Divider,
  BoxAvisoPagamentoAgendado,
} from './styles'
import { usePagamentoBoleto } from '../../../../hooks/usePagamentoBoleto'
import { isValidValue } from '../../../../../../shared/utils/validates'
import { Grid } from '@material-ui/core'
import logoTmovPay from './../../../../../../shared/assets/images/logoTmovPayGreen.svg'
import { format } from 'date-fns'
import { TextBoleto } from '../DetalhePagamentoBoleto/styles'
import { colors } from '../../../../../../shared/styles/colors'
import {
  formatBankSlip,
  numberToCurrency,
} from '../../../../../../shared/utils/formatters'
import { useCartao } from '../../../../hooks/useCartao'
import { MdInfoOutline } from 'react-icons/all'

interface ComprovanntePagamentProp {
  protocolo: string
}
// eslint-disable-next-line react/display-name
const ComprovantePagamento = React.forwardRef<
  React.ReactElement,
  React.PropsWithChildren<ComprovanntePagamentProp>
>((props, ref) => {
  const { boleto } = usePagamentoBoleto()
  const { cartao } = useCartao()

  return (
    <HiddenContainer>
      {isValidValue(boleto) && (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <Container ref={ref}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                style={{
                  textAlign: 'center',
                }}
              >
                <Grid item xs={12}>
                  <img src={logoTmovPay} height={40} />
                </Grid>
                <Grid item xs={12}>
                  <TextBoleto
                    $fontSize={'18px'}
                    $fontWeight={'700'}
                    $color={colors.gray1}
                  >
                    Comprovante de pagamento
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'14px'}
                    $fontWeight={'400'}
                    $color={colors.gray}
                  >
                    {format(new Date(), 'dd/MM/yyyy H:mm:ss')}
                  </TextBoleto>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                style={{
                  margin: 16,
                }}
              >
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'18px'}
                      $fontWeight={'700'}
                      $color={colors.gray1}
                    >
                      Detalhes
                    </TextBoleto>
                  </Grid>
                </Box>
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Favorecido
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {boleto.favorecido}
                    </TextBoleto>
                  </Grid>
                </Box>

                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Valor
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Desconto
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {numberToCurrency(boleto?.valor ?? 0)}
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {numberToCurrency(boleto?.valor_desconto ?? 0)}
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Multa
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Juros
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {numberToCurrency(boleto?.valor_multa ?? 0)}
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {numberToCurrency(boleto?.valor_juros ?? 0)}
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Valor total
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {numberToCurrency(boleto?.valor_total ?? boleto.valor ?? 0)}
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Vencimento
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Pagamento
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {format(boleto.data_vencimento, 'dd/MM/yyyy')}
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {format(new Date(), 'dd/MM/yyyy')}
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Código
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: 8,
                    wordBreak: 'break-all',
                    paddingRight: 32,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {formatBankSlip(boleto.codigo_barras)}
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Protocolo
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: 8,
                    wordBreak: 'break-all',
                    paddingRight: 32,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {props.protocolo}
                  </TextBoleto>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'18px'}
                      $fontWeight={'700'}
                      $color={colors.gray1}
                    >
                      Pagador
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Nome
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {cartao.titular}
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      {isValidValue(cartao?.conta) ? 'Conta' : 'Cartão'}
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {cartao?.conta ?? cartao?.identificador}
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Meio de pagamento
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      TMOV Pay
                    </TextBoleto>
                  </Grid>
                </Box>
                {boleto.data_agendamento && (
                  <>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={12}>
                      <BoxAvisoPagamentoAgendado>
                        <Grid container spacing={0}>
                          <Grid item xs={1}>
                            <MdInfoOutline size={18} />
                          </Grid>
                          <Grid item xs={11}>
                            <TextBoleto
                              $fontSize={'16px'}
                              $fontWeight={'400'}
                              $color={colors.gray7}
                            >
                              A quitação efetiva desse boleto dependerá da
                              validação das condições de pagamento junto ao
                              favorecido e da existência de saldo na sua conta
                              Tmov Pay às 23:45hrs da data escolhida. O
                              comprovante definitivo somente será emitido e
                              enviado por e-mail após a quitação.
                            </TextBoleto>
                          </Grid>
                        </Grid>
                      </BoxAvisoPagamentoAgendado>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      )}
    </HiddenContainer>
  )
})

export default ComprovantePagamento
